'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contextualNodeAttributes", "menuItems"];
import tinymce from 'tinymce';
import IconTypeToolbarControl from 'rich-text-lib/components/toolbar/IconTypeToolbarControl';
import { CANVAS_ICON_TYPE } from '../../../constants/toolbar';
import { jsx as _jsx } from "react/jsx-runtime";
export function addContextualIconTypeControl(editor) {
  const handleIconTypeChange = (target, iconType) => {
    editor.fire('hsIconTypeChange', {
      target,
      iconType
    });
  };
  tinymce.canvas.addButton(editor, CANVAS_ICON_TYPE, {
    renderControl: props => {
      const {
          contextualNodeAttributes
        } = props,
        rest = _objectWithoutPropertiesLoose(props, _excluded);
      const {
        iconType,
        availableIconTypes,
        activeElement
      } = contextualNodeAttributes;
      return /*#__PURE__*/_jsx(IconTypeToolbarControl, Object.assign({}, rest, {
        "data-test-id": CANVAS_ICON_TYPE,
        iconType: iconType,
        availableIconTypes: availableIconTypes,
        onChange: handleIconTypeChange.bind(null, activeElement)
      }));
    }
  });
}